import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useDepartmentsData(companyId?: number) {
    const { data: departmentsData } = useQuery({
        queryKey: ['departments-data'],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.salary.employees.departments-data', companyId),
            );
            return data;
        },
        placeholderData: [],
        enabled: !!companyId,
    });

    return {
        departmentsData,
    };
}
